<template>
  <div>
    <px-view-header title="Mensagens Personalizadas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-mensagem-personalizada-lista-header :on-click-refresh="onClickRefresh"
                                            :on-change-filter="onChangeFilter"/>
    <px-mensagem-personalizada-lista :messages="messages"
                                     :loading="loading"
                                     :on-change-options="onChangeOptions"
                                     :options-list="optionsList"
                                     :footer-options="footerOptions"
                                     @remove="onRemove"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-cotacao/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import MessageService from './service/messages-service';
import MensagemPersonalizadaLista from './listagem/MensagemPersonalizadaList.vue';
import MensagemPersonalizadaListaHeader from './listagem/MensagemPersonalizadaListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Mensagens Personalizadas' },
      ],
      messages: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemMensagens', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemMensagens', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getMessages();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getMessages();
    },
    onClickRefresh() {
      this.getMessages();
    },
    onRemove(item) {
      this.loading = true;
      MessageService.remover(item.id)
        .then(() => {
          this.$toast('Mensagem removida com sucesso', { color: 'success' });
          this.getMessages();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getMessages() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return MessageService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.messages = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxMensagemPersonalizadaLista: MensagemPersonalizadaLista,
    pxMensagemPersonalizadaListaHeader: MensagemPersonalizadaListaHeader,
  },
};

</script>
